import { PlAYWIRE_AD_PLACEMENT_SIZES } from '../../internal/config/playwire-ad-placement-sizes';

export const playwireAdPlacementSizeKey = {
  HEAD_1: 'standard_iab_head1',
  RIGHT_1: 'standard_iab_rght1',
  RIGHT_2: 'standard_iab_rght2',
  RIGHT_3: 'standard_iab_rght3',
} as const;

export type PlaywireAdPlacementSizeKey =
  (typeof playwireAdPlacementSizeKey)[keyof typeof playwireAdPlacementSizeKey];

type PlaywireAdPlacementBase = {
  code?: string;
  shouldRefresh?: boolean;
  refreshTimeInSeconds?: number;
  targeting?: Record<string, string>;
  type: PlaywireAdPlacementSizeKey;
};

export type PlaywireAdPlacement = StandardAdPlacement | BottomRail | CornerAdVideo | FlexSuite;

export type BottomRail = { type: 'bottom_rail' };
export type CornerAdVideo = { type: 'corner_ad_video' };
export type FlexSuite = { type: 'flex' };

export type StandardAdPlacement =
  | (PlaywireAdPlacementBase & { size: typeof PlAYWIRE_AD_PLACEMENT_SIZES.standard_iab_head1 })
  | (PlaywireAdPlacementBase & { size: typeof PlAYWIRE_AD_PLACEMENT_SIZES.standard_iab_rght1 })
  | (PlaywireAdPlacementBase & { size: typeof PlAYWIRE_AD_PLACEMENT_SIZES.standard_iab_rght2 })
  | (PlaywireAdPlacementBase & { size: typeof PlAYWIRE_AD_PLACEMENT_SIZES.standard_iab_rght3 });
